import React, { Component } from 'react';
import Message from './ValidationMessage';

export class DropdownFieldEdit extends Component {


  render() {
    let {
      intl,
      translation,
      input,
      required,
      placeholder,
      label,
      list = [],
      activeOnly = true,
      id,
      idField = 'id',
      displayField = 'name',
      disabled,
      meta: { touched, error, warning }
    } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if(placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
      }
    }

    let showError = touched && error ? 'error' : '';
    const requiredClass = required ? 'required' : '';
    const name = input ? input.name : '';

    const optionList = list.reduce((accumulator = [], item) => {
      if (item) {
        const idVal = item[idField];
        if (idVal != null) {
          const optionId = idVal;
          const optionValue = idVal;
          const optionLabel = item[displayField];

          if (activeOnly) {
            if (!item.hasOwnProperty('active') || item.active) {
              accumulator.push((
                <option key={optionId} value={optionValue}>{optionLabel}</option>
              ));
            }
          }
          else {
            accumulator.push((
              <option key={optionId} value={optionValue}>{optionLabel}</option>
            ));
          }
        }
      }

      return accumulator;
    }, []);

      return (
        <div className={`${requiredClass} field ${showError}`}>
          <label>{label}</label>
          <select {...input} className={`ui search compact dropdown renderDropdown ${name}`} id={id} name={name} disabled={disabled} placeholder={placeholder}>
            <option value=""></option>
            {optionList && optionList};
          </select>
          <Message show={touched} message={error} />
          <Message show={touched} message={warning} />
        </div>
      );


  }
}
